<template>

  <div>

  <div v-if="type == 'A'">


     <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>


   
    <printZebraModal :key="refreshZPL" v-bind:data='data'></printZebraModal> 
    <print-epl-modal :key="refreshEPL" v-bind:data='data'></print-epl-modal> 

  
    <div class="row_">                  
    <div class="col-12_">  

        <div class="card border-0">

        
        <div class="btn-group" role="group" aria-label="Basic example">
          <button  @click="$emit('supplierDocuments')" class="btn btn-secondary mb-1 ">      
        <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
        RITORNA A LISTA DOCUMENTI
        </button>    
                    
        <button  @click="$emit('addProduct',2)" class="btn btn-primary _add-product mb-1 ">      
           <i style="color:wheat" class="fas fa-edit mr-2" aria-hidden="true"></i>
           AGGIUNGI PRODOTTO AL DOCUMENTO
        </button>

        </div>
        </div>
     



      <div  class="table-wrapper-scroll-y my-custom-scrollbar table-responsive-sm">
      <table class="table table-sm table-bordered table-hover mt-1 table-striped mb-0" id="table">
        
      <thead class="header_">


        <tr class="header">
            <th class="text-center" :colspan="14" style="" >                             
               <document-header class="text-center"  v-bind:doc="doc" v-bind:textColor="'white'" ></document-header>   
            </th> 
        </tr>

        <tr>
          <th>#</th>
          <th></th>
          <th></th>
          <th>ID PRODOTTO</th>
                  
          <th>STAGIONE</th>
          <th>CODICE ARTICOLO</th>
          <th>BRAND</th>
          <th>CATEGORIA</th>
          <th>COMPOSIZIONE</th>
          <th>REPARTO</th>
          <th class="text-right">Q.TA'</th>
          <th class="text-right">COSTO €</th>
          <th class="text-right">TOTALE</th>
          <th class="text-center">% SCONTO</th>
          
          
        </tr>
      </thead>
      <tbody>

      <tr @dblclick="editRow(product)" data-toggle="tooltip" title="doppio click modifica carico e listino varianti."   class="pointer" v-for="(product,index) in filteredProducts" :key="index">

        <td>{{index+1}}</td>
         <td>
          <div class="dropdown">
                    <button style="color:black;background-color: white;" class="btn btn-info btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                        <i class="fas fa-ellipsis-v mr-2" aria-hidden="true"></i>
                        OPZIONI
                    </button>
                    <div class="dropdown-menu ">

                    <a  class="dropdown-item" @click="stock(product)" href="#">
                    <i style="color:brown" class="fas fa-database mr-2" aria-hidden="true"></i>
                        Esistenza prodotto</a>
                    <a  class="dropdown-item" @click="tab(product)" href="#">
                    <i style="color:darkgreen" class="fas fa-columns mr-2" aria-hidden="true"></i>
                        Scheda prodotto </a>
                    
                    <div class="dropdown-divider"></div>   
                    <a   class="dropdown-item" @click="printModal(product)" href="#">
                    <i   style="color:blueviolet" class="fas fa-print mr-2" aria-hidden="true"></i>
                        Stampa etichette 
                        <span v-if="spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
                      </a>
                    

                        
                    </div>
                    </div>
         </td>
         <td class="text-center"> <span :class="{dotRed:product.colorCount > 0}"></span></td>
        <td>{{product.productId}}</td>

       
        
        <td>{{product.seasonYear}}</td> 
        <td>{{product.sku}}</td>
        <td>{{product.brand.toUpperCase()}}</td>
        <td >{{product.category}}</td>
        <td >{{product.material}}</td>
        <td >{{product.department}}</td>
        <td class="text-right">{{product.qtyItem}}</td>
        <td class="text-right">{{fmt1(product.price)}}</td>
        <td class="text-right">{{fmt1(product.totalItem)}}</td>
        <td class="text-center">{{product.discount_list}}</td>
        

      </tr>
      </tbody>
      <tfoot>
           <tr>
         
          <th></th>
          <th>

             <button v-if="true" :disabled="filteredProducts.length==0" @click="printDocument()"  class="btn btn-outline-info mt-2 ml-2">
      <i  class="fas fa-print mr-2" aria-hidden="true"></i>
      STAMPA DOCUMENTO
      <span v-if="bt_spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </button>
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>

          <th class="text-right">{{totalQty}}</th>
          <th></th>
          <th class="text-right">{{fmt1(totalVal)}}</th>
          <th></th>
        
        </tr>
      </tfoot>  
    </table>
  </div>
  <label for="cerca"><strong>Filtra</strong></label>
         <input class="form-control" type="text" name="query" v-model="filterKey">

  

  </div>
  </div>
  


    <!-- BODY CARD -->
  </div>
    
   
  

    
 


  <div v-else-if="type =='Stock'">
    <product-stock @close="closeProductStock()" v-bind:item="item"/>
  </div>
  <div v-else-if="type=='Tab'">
    <tab :btn_text="'RITORNA A LISTA PRODOTTI'" @close="closeTab()" v-bind:product="item" ></tab>
  </div>

  <div v-if="false">
      <h5 class="mb-4">Dati JSON:</h5>
      <pre> {{ doc }}</pre> 
      
    </div>


  </div>
</template>

<script>


import { mapGetters } from 'vuex';
import api             from '@/api'



import printZebraModal  from '@/components/common/PrintZebraModal.vue'
import printEplModal    from '@/components/common/PrintJSPMModal.vue'
import jsPDF            from 'jspdf'
import fmt              from '@/components/mixins/fmt.js'

import productStock      from '@/components/product/productStock.vue' 
import tab               from '@/components/backOffice/ready/tab/ProductTab.vue' 


import modalMessage      from '@/components/modalDialog/ModalMessage.vue'   
import documentHeader    from '@/components/backOffice/ready/DocumentHeader.vue'


  export default {
     props  : ['doc'],
     mixins : [fmt],
     components: {printZebraModal,printEplModal,productStock,tab,modalMessage,documentHeader},
    data () {
      return {

        stockMovementId : this.doc.stockMovementId,
        type            : 'A',
        productId       : 0,
        
        items           : [],
        
        filterKey     : '',
        spinner       : false,
        pdf           : '',
       
        bt_spinner    : false,        
        item          : null,
        
        
        refreshEPL    : 0,
        refreshZPL    : 100,
        data          : []
        
      }
    },
    watch :
    {

    },
    
  
    computed: {
      ...mapGetters(['company']),
      filteredProducts : function () 
      {
        
        
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) 
        {
            items = items.filter(function (row) 
            {
                return Object.keys(row).some(function (key) {
                return String(row[key]).toLowerCase().indexOf(filterKey) > -1
              })
            })
        }
        return items

     },
     
       


     
     
      totalQty ()  
      {
        var totale = 0
          this.items.forEach(item => {
             totale = totale + Number(item.qtyItem)
          
        });
       
        return totale
      },
      totalVal ()
      {
        var totale = 0
        
          this.items.forEach(item => {
            totale = totale + Number(item.totalItem)
          
          });
        
        return totale
      },
      
      
    },
    mounted()
    { 

     
     if(this.stockMovementId)
     {
        const obj = {stockMovementId : this.stockMovementId}
        this.getData(obj)  
     }
      
    },
    created () 
    {
      
      //this.row = localStorage.getItem('LastRow');
      //console.log(this.row)

    },
    beforeDestroy()
    {
      
      //console.log('Row',this.row)

    },
    methods: 
    {
      closeProductStock()
      {
       
        this.type = 'A'
      },
      closeTab()
      {

       
        this.type = 'A'
        
      },
      async printModal(item)
      {
        
        let lang = this.company.printer_type
        
        this.data = await this.getDataToPrint(item)
       
        if(this.data.length == 0) return


        if(lang=='EPL')
        {
          this.refreshEPL++
          this.$nextTick(() => {
            $('#printEPLModal').modal({keyboard: false,backdrop:'static','show':true});
            })
        }
        else
        {
          this.refreshZPL++
          this.$nextTick(() => {
           $('#printZebraModal').modal({keyboard: false,backdrop:'static','show':true});
            
        })  
        }
        
      },

      
    
      tab(product)
      {
        //this.$emit('showButtons',false)
        this.item = product
        this.type = 'Tab'
        
      },

      stock(product)
      {
        this.item = product
        this.type = 'Stock'
        //this.$emit('showButtons',false)
        //this.$emit('option',product,'stock')
         
        
      },
      editRow(item)
      {
       // console.log('Product',item)
        this.$emit('editRow',item)
      },
   


      async printDocument()
      {
    
      const doc = new jsPDF()

      this.spinner2 = true  
      var page = 1
      
      let items = []
      
      this.filteredProducts.forEach(item =>{
        items.push(item)
      })
      
      
      items.sort((a, b)=>{
      let x = a.department.toLowerCase();
      let y = b.department.toLowerCase();
        if (x < y) {return -1;}
        if (x > y) {return 1;}
        return 0;
      });
      
      

      let document = await this.getDocument()
        if(document.length == 0) 
        {
          return
        }
       let title = {type:document[0].description,data:document[0].date,number : document[0].number,supplier:document[0].supplier }
        
      var pages = parseInt(items.length / 50) == items.length / 50 ? parseInt(items.length / 50) : parseInt(items.length / 50) + 1
      
      var row_index = 1
      var page_index = 1
      var init_row = 31
      var row = init_row
      var row_header = row -5

      //var col = 5
      var col1 = 10
      var col2 = 50
      var col3 = 70
      var col4 = 100
      //var col5 = 121
      //var col6 = 150
      var col7 = 120
      var col8 = 180
      var col9 = 205
      //var total = 0
      //var row_count = 0
      //var doc = new jsPDF()

      var header = function(title)
      {
        var d = new Date();
        var n = d.toLocaleString();
        doc.setFontSize(14)
        
        doc.setFont("helvetica",'bold')
        doc.text(title.supplier + ' ' + title.type + ' ' + title.number + ' ' + title.data,  105, 10, null, null, "center");

        doc.setTextColor(0, 0, 255);
        //doc.text(customer,  105, 15, null, null, "center");
        doc.setTextColor(0, 0, 0);
        
       // doc.text('CASSA ' + description3,  105, 20, null, null, "center");
        
        
      
        doc.setFontSize(10)
      
        doc.text('ARTICOLO', col1,row_header);
        doc.text('BRAND', col2, row_header);
        doc.text('CATEGORIA', col3, row_header);
        doc.text('REPARTO', col4, row_header);
       // doc.text('MATERIALE', col5, row_header);

      //  doc.text('DIMENSIONE', col6, row_header,null,null,'right');
        doc.text('STAGIONE', col7, row_header);
        doc.text('Q.tà', col8, row_header,null,null,'right');
        doc.text('TOTALE', col9, row_header,null,null,'right');
        doc.setFont("helvetica",'normal')
        

      }
      var footer = function()
      {
        doc.setFontSize(8)
        doc.text('pag. ' + page.toString() + ' / ' + pages.toString(),  105, 290, null, null, "center");
       
      }
      header(title)
      footer()


      items.forEach(item=>{
               
        doc.setFontSize(8)
       
       
       
        doc.setFont("helvetica",'normal')
        
        doc.text(item.sku.toString().substr(0,50), col1, row);
        doc.text(item.brand.toString().substr(0,10), col2, row);  
        doc.text(item.category.toString().substr(0,20), col3, row);
       
        
        doc.text(item.department.toString(), col4, row);
        doc.text(item.seasonYear.toString(), col7, row);
        doc.text(item.qtyItem.toString(), col8, row,null,null,'right');
        doc.text(this.fmt1(item.totalItem.toString()), col9, row,null,null,'right');
        
        //row_count++

         
        

        
        if(page_index == 50 && row_index < items.length)
        {
          page++  
          doc.addPage("a4");
          header(title)
          footer()
          row = init_row
          row_index++
          page_index = 1
        }
        else
        {
          row = row + 5
          row_index++
          page_index++
        }
        
      })
      doc.setFontSize(10)
      
      doc.rect(5, 282, 203, 4)
      
      
      doc.setFont("helvetica",'bold')
      doc.text('TOTALE DOCUMENTO' ,  10, 285, null, null);  
      doc.text(this.totalQty.toString() ,  180, 285, null, null, "right");
      doc.text(this.fmt1(this.totalVal) ,  205, 285, null, null, "right");
      
      let fileName = 'Document_' + Date.now().toString()
      window.open(doc.output('bloburl', { filename: fileName }), '_blank');
      this.spinner2 = false

    },

  
      async getDocument()
      {
        
        const documentId =  this.doc.documentId
        const sp         = 'spDocumentCollectionHeader'        
        const payload    = {documentId,sp}
       try{ 
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
          return res.data.recordsets[0]
          }
          catch(err)  
          {
            return []
          }


      },


      async getDataToPrint(item) 
      {
      
        
        const sp      =  'spStockMovementProductBarcodes'
        const payload = {'productId' : item.productId,'movementId':item.stockMovementId,sp}
         try{
        
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
             this.$refs.msgModal.close() 
             return res.data.recordsets[0]

        }catch(err){

            this.$refs.msgModal.setSpinner(false)
            this.$refs.msgModal.show(err) 
            return []
        }
        


        

      }, 
    








async getData(item)
    {
        
        this.$refs.msgModal.show()        
        this.$refs.msgModal.setSpinner(true)  
        const sp       = 'spSupplierStockMovementProducts'
        const payload  = {...item,
                          sp
                        }                
        try{
        
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
             this.$refs.msgModal.close() 
             this.items = res.data.recordsets[0]

        }catch(err){

            this.$refs.msgModal.setSpinner(false)
            this.$refs.msgModal.show(err) 
        }
        
        
      },



      
     
     
      deleteProduct (id) {
        console.log(id)
      
      }
      

    }
  }
</script>
<style scoped>
  

.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}
 

.table {
  border-collapse: separate;
}


.my-custom-scrollbar {
  height: 500px;
  overflow-y: auto;
}

.table-wrapper-scroll-y {
  display: block;
}

/* tutti gli header */
.table thead th {
  position    : sticky;
  background  : #5c8fb1;
  color       : white;
  z-index     : 10;
}

/* prima riga */
.table thead tr:nth-child(1) th {
  top         : 0;
  z-index     : 20;
   color      : rgb(16, 16, 15) !important;
  
   background  : #5c8fb1;
}

/* seconda riga */
.table thead tr:nth-child(2) th {
  top         : 50px;   /* altezza reale della prima riga */
  z-index     : 19;

  color       : rgb(16, 16, 15) !important;
  background  : #a9cbe2;

}



  
  p,h4 {
  font-family : 'Roboto Condensed';
  font-size   : 20px;
   }


.dotGreen
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: green;
}
.dotRed
{
  height: 10px;
  width: 10px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: red;
}
.fa-database
{
  color : #736AFF;
  
}


.fa-columns
{
  color : chocolate;
}
.fa-database:hover{
  color : white
}
.fa-columns:hover{
  color : white;
}

.table,
.table th, 
.table td
{
  border-color: #3b28a7 !important;
}



.table tfoot  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 20px;
    background   : whitesmoke;
    color        : green;  
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }
</style>
